import { getDisplayOptionsQuery } from 'AppSrc/core/components/forms/form-base-components/redux/display-options/display-options-queries';
import { setErrorAlert } from 'AppSrc/core/actions/actions-error-alert';


const getShouldPreventRefresh = (params) => {
  const {
    state,
    preventRefresh,
    fieldId,
  } = params;

  const currentDisplayOptions = state.displayOptions.displayOptionsDataById[fieldId];

  if (preventRefresh && currentDisplayOptions) {
    return true;
  }

  return false;
};



const FETCH_DISPLAY_OPTIONS_REQUEST = 'FETCH_DISPLAY_OPTIONS_REQUEST';
const FETCH_DISPLAY_OPTIONS_SUCCESS = 'FETCH_DISPLAY_OPTIONS_SUCCESS';
const FETCH_DISPLAY_OPTIONS_ERROR = 'FETCH_DISPLAY_OPTIONS_ERROR';
const CLEAR_DISPLAY_OPTIONS_FOR_FIELD_ID = 'CLEAR_DISPLAY_OPTIONS_FOR_FIELD_ID';

const fetchDisplayOptionsRequest = (fieldId) => ({
  type: FETCH_DISPLAY_OPTIONS_REQUEST,
  payload: {
    fieldId,
  },
});

const fetchDisplayOptionsSuccess = ({
  fieldId,
  displayList,
  displayOptions,
}) => ({
  type: FETCH_DISPLAY_OPTIONS_SUCCESS,
  payload: {
    fieldId,
    displayList,
    displayOptions,
  },
});

const fetchDisplayOptionsError = (fieldId) => ({
  type: FETCH_DISPLAY_OPTIONS_ERROR,
  payload: {
    fieldId,
  },
});

const clearDisplayOptionsForId = (fieldId) => ({
  type: CLEAR_DISPLAY_OPTIONS_FOR_FIELD_ID,
  payload: {
    fieldId,
  },
});


const getDisplayOptions = (params) => (dispatch, getState) => {
  const {
    fieldId,
    endpointKey,
    endpointParams,
    preventRefresh,
  } = params;

  const state = getState();
  const shouldPreventRefresh = getShouldPreventRefresh({
    state,
    preventRefresh,
    fieldId,
  });
  if (shouldPreventRefresh) {
    return Promise.resolve(null);
  }


  dispatch(fetchDisplayOptionsRequest(fieldId));

  return getDisplayOptionsQuery({
    endpointKey,
    endpointParams,
  })
    .then((displayList) => {
      dispatch(fetchDisplayOptionsSuccess({
        fieldId,
        displayList,
      }));
    })
    .catch((error) => {
      dispatch(fetchDisplayOptionsError(fieldId));
      dispatch(setErrorAlert({
        errorTitle: 'Unable to retrieve display options',
        errorText: 'Please try again later',
      }));
    });
};


const getAndClearDisplayOptions = (params) => (dispatch, getState) => {
  const {
    fieldId,
    preventRefresh,
    displayOptionsToClear,
  } = params;

  const state = getState();
  const shouldPreventRefresh = getShouldPreventRefresh({
    state,
    preventRefresh,
    fieldId,
  });
  if (shouldPreventRefresh) {
    return Promise.resolve(null);
  }


  displayOptionsToClear.forEach((fieldIdToClear) => dispatch(clearDisplayOptionsForId(fieldIdToClear)));
  // the prevent refresh logic is duplicated in getDisplayOptions but it's needed here also to prevent
  // clearing display options
  dispatch(getDisplayOptions(params));
  return null;
};


export {
  FETCH_DISPLAY_OPTIONS_REQUEST,
  FETCH_DISPLAY_OPTIONS_SUCCESS,
  FETCH_DISPLAY_OPTIONS_ERROR,
  CLEAR_DISPLAY_OPTIONS_FOR_FIELD_ID,
  fetchDisplayOptionsRequest,
  fetchDisplayOptionsSuccess,
  fetchDisplayOptionsError,
  getAndClearDisplayOptions,
  getDisplayOptions,
};
